module.exports = __webpack_public_path__ + "img/fr.54826494.svg";